import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Image, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';
import logo from '../../../assets/logo_stride.png';
import { AuthActionEnum, ErrorMessageEnum } from "../../../enums/app.enum";
import { useAuthState } from "../../../states/auth.state";
import { utils } from '../../../_helpers';
import SInputComponent from '../../s-input/s-input.component';
import CloseIcon from '../close-icon/close-icon.component';
import PrivacyPolicyModal from '../privacy-pocily-modal/privacy-pocily-modal.component';
import TermUseModal from '../term-use-modal/term-use-modal.component';
import './login-modal.component.scss';
import { useToasts } from 'react-toast-notifications';

/**
 * Modal delect
 * @param {*} props Modal props
 * @param {*} props.onHide callback function when close modal
 * @param {*} props.pathto path redirect after login
 * @returns
 */
const LoginModal = (props: any) => {
  const history = useHistory();
  const authState = useAuthState();
  const { clearErrors, control, handleSubmit, setError, formState: { errors } } = useForm();
  const { addToast } = useToasts();
  const [showTC, setshowTC] = useState(false)
  const [showTU, setshowTU] = useState(false)
  const [showVerifyForm, setShowVerifyForm] = useState(false);
  const [verifyTimer, setVerifyTimer] = useState(0);


  const handleOpenSignup = () => {
    props.onHide(AuthActionEnum.OPEN_SIGNUP)
  }

  const handleOpenForgot = () => {
    props.onHide(AuthActionEnum.OPEN_FORGOT)
  }

  const onSubmit = (formData: any) => {
    authState.login(formData.username, formData.password)
      .then(res => {
        props.onHide()
        history.push('/booking-create')
      }).catch(err => {
        clearErrors()
        addToast(err.response?.data?.error || 'Incorrect Login Information. Please try again', { appearance: 'error' })
      })
  }

  const onVerifySubmit = (formData: any) => {
    authState.verifyToken({ token: formData.token }).then(res => {
      props.onHide()
      if (props.pathto) history.push(props.pathto)
      else {
        if (res.data.need_update === 1) {
          history.push('/user-profile-setting?action=edit')
        }
      }
    }).catch(err => {
      clearErrors()
      setError('password', { type: 'manual', message: err.response.data?.error })
    })
  }

  useEffect(() => {
    let timer: any
    if (verifyTimer === 0) {
      clearInterval(timer)
      setShowVerifyForm(false)
    }
    if (verifyTimer > 0) {
      timer = setInterval(() => {
        setVerifyTimer(verifyTimer - 1);
      }, 1000);
    }
    // clearing interval
    return () => {
      if (timer) {
        clearInterval(timer)
      }
    }
  }, [verifyTimer])

  return (
    <Modal {...props} animation={false} centered>
      <Modal.Body className="text-center">
        <CloseIcon onClicked={props.onHide} />
        <Container>
          <Row>
            <Col>
              <Image src={logo} className="my-4" style={{ width: 'inherit' }}/>
              <div>
                <p className='text-14'>
                  By entering to this website, you accept our <span className='text-primary pointer fw-7' onClick={() => setshowTU(true)}>Terms of Use </span>
                  and our <span className='text-primary pointer fw-7' onClick={() => setshowTC(true)}>Privacy Policy</span>
                </p>
              </div>
              <Row>
                <Col className='px-md-5'>
                  {!showVerifyForm && (
                    <>
                      <Form className="my-4" onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group className="mb-3 my-1" controlId="formBasicEmail">
                          <SInputComponent name="username" type='text' placeholder="Username" control={control} error={errors.username}
                            rules={{
                              required: { value: true, message: ErrorMessageEnum.requiredFieldMessage }
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 my-1" controlId="formBasicPassword">
                          <SInputComponent name="password" type='password' placeholder="Password" control={control} error={errors.password}
                            rules={{
                              required: { value: true, message: ErrorMessageEnum.requiredFieldMessage }
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicCheckboxLogin">
                          <Form.Check type="checkbox" label="Keep me signed in" />
                        </Form.Group>
                        <div className="d-grid gap-2">
                          <Button type="submit" variant="danger" size="lg" className="btn-block">Login</Button>
                        </div>
                      </Form>
                    </>
                  )}

                  {showVerifyForm && (
                    <Form className="my-4" onSubmit={handleSubmit(onVerifySubmit)}>
                      <Form.Group className="mb-3 my-1 position-relative" controlId="formBasicEmail">
                        <span className="verify-timer">{verifyTimer}</span>
                        <SInputComponent name="token" type='text' placeholder="Token" control={control} error={errors.token} />
                      </Form.Group>
                      <div className="d-grid gap-2">
                        <Button type="submit" variant="danger" size="lg" className="btn-block">Verify</Button>
                      </div>
                    </Form>
                  )}
                </Col>
              </Row>
              {!showVerifyForm && (
                <div className="d-flex justify-content-between mb-4 mt-2">
                  <span className='text-primary pointer text-14 letter-86' onClick={handleOpenForgot}><b>Forgot Password</b></span>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      {showTC && <PrivacyPolicyModal show={showTC} onHide={() => setshowTC(false)} onOk={() => setshowTC(false)} />}
      {showTU && <TermUseModal show={showTU} onHide={() => setshowTU(false)} onOk={() => setshowTU(false)} />}
    </Modal >
  );
}

export default LoginModal;
